export const dashboard = {
  contact: {
    title: 'Загрузить контакты',
    button: 'Загрузить',
    description:
      'Чтобы начать работу в Zorra, импортируйте базу данных ваших клиентов или добавьте номера.'
  },

  mailing: {
    title: 'Создать рассылку',
    button: 'Создать',
    description: 'Создайте сообщение для смс, используя заготовленные шаблоны.'
  },

  number: {
    title: 'Заказать номер',
    button: 'Заказать',
    description: 'В процессе покупки может потребоваться дополнительная информация.'
  },

  pbx: {
    title: 'Настроить виртуальную АТС',
    button: 'Настроить',
    description: 'Сервис Zorra может предоставить облачное решение для сервера VoIP-телефонии.'
  },

  api: {
    title: 'API и Интеграция',
    button: 'Интегрировать',
    description:
      'Сервис Zorra позволяет интегрировать мощные сервисы. Чтобы использовать Zorra API, вы должны добавить IP-адрес вашего сервера здесь'
  },

  prices: {
    title: 'Все сервисы и цены',
    button: 'Изучать',
    description: 'Хотите внедрить почтовую рассылку, но не знаете, что для этого нужно?'
  },

  first_entry: {
    title: 'Спасибо за регистрацию!',
    text: `Учетные данные были отправлены на вашу электронную почту. <br /> На ваш счет зачислены <b>{value} приветственных {currency}.</b>`,
    start: 'Начать работу'
  },

  'phone-line': {
    title: 'Настроить входящую линию',
    description:
      'Автоматизируйте вашу телефонию. Различные сценарии обработки входящих вызовов в зависимости от структуры, графика работы и бизнес-задач вашей компании.',
    button: 'Настроить'
  },
  'client-info': {
    title: 'Запустить информирование клиентов',
    description:
      'Полностью автоматизированный тип обзвона. Проинформирует ваших клиентов об акциях без участия операторов.',
    button: 'Запустить'
  },
  'buy-numbers': {
    title: 'Купить номера',
    description:
      'Подключите наши многоканальные виртуальные номера. Клиенты всегда смогут дозвониться, а вы не пропустите ни одного входящего звонка.',
    button: 'Купить'
  },
  'data-base': {
    title: 'Обзвонить базу клиентов',
    title2: 'Предиктивный обзвон',
    description:
      'Предиктивный обзвон позволяет быстро обзвонить большой объем номеров и при этом обеспечить практически 100% загрузку операторов.',
    button: 'Перейти',
    button2: 'Подключить'
  },

  noty: {
    'connect-autocaller': 'Предиктивный обзвон будет подключен в течение нескольких минут.'
  },

  'low-balance': 'Средства на вашем балансе подходят к концу, рекомендуем пополнить его.',
  'unavailable_zorra': 'Предупреждение о технических работах: сервис будет недоступен 6 декабря 2023 года с 07:00 до 11:00 UTC',

  captcha:
    'This site is protected by reCAPTCHA and the Google <br />' +
    'Privacy Policy and Terms of Service apply.'
};
